module.exports = __webpack_public_path__ + "img/720.32f62361.svg";